import React from "react"
import { useTranslation } from "react-i18next"
import "./FilterSidebar.css"
interface filterSidebarProps {
  filterSidebar?: boolean
  handleFilterSidebar?: () => void
  resetFilter?: () => void
  children: React.ReactElement[]
}

const FilterSidebar = (props: filterSidebarProps) => {
  const { t } = useTranslation("common")
  const { filterSidebar, handleFilterSidebar, resetFilter } = props
  return (
    <div className={filterSidebar ? "showPosition d-flex flex-column d-lg-none" : "d-none"}>
      <div className="filterTitle d-flex justify-content-between align-items-center">
        <div className="w-100">
          <h3>Filter</h3>
        </div>
        <button className="button icon-medium icon-circle tertiary" onClick={handleFilterSidebar}>
          <i className="iocn-font tc-icon-content-close"></i>
        </button>
      </div>
      <div className="filter-container">
        <div className="filters">
          <div className="filter-div d-flex flex-column">
            <div className="filter-type-sidebar">{props.children}</div>
          </div>
        </div>
      </div>
      <div className="footer d-flex justify-content-center align-items-center">
        <button className="button primary" onClick={resetFilter}>
          {" "}
          {t("reset", { ns: "common" })}
        </button>
      </div>
    </div>
  )
}

export default FilterSidebar
